export default "__VITE_ASSET__a113d792__"